export default {
    ariaBack: 'Ir al anterior',
};
